function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// tslint:disable max-classes-per-file
import { getBundleURL } from "./get-bundle-url.browser";
export var defaultPoolSize = typeof navigator !== "undefined" && navigator.hardwareConcurrency ? navigator.hardwareConcurrency : 4;

var isAbsoluteURL = function isAbsoluteURL(value) {
  return /^[a-zA-Z][a-zA-Z\d+\-.]*:/.test(value);
};

function createSourceBlobURL(code) {
  var blob = new Blob([code], {
    type: "application/javascript"
  });
  return URL.createObjectURL(blob);
}

function selectWorkerImplementation() {
  if (typeof Worker === "undefined") {
    // Might happen on Safari, for instance
    // The idea is to only fail if the constructor is actually used
    return function NoWebWorker() {
      _classCallCheck(this, NoWebWorker);

      throw Error("No web worker implementation available. You might have tried to spawn a worker within a worker in a browser that doesn't support workers in workers.");
    };
  }

  var WebWorker = /*#__PURE__*/function (_Worker) {
    _inherits(WebWorker, _Worker);

    var _super = _createSuper(WebWorker);

    function WebWorker(url, options) {
      _classCallCheck(this, WebWorker);

      var _a, _b;

      if (typeof url === "string" && options && options._baseURL) {
        url = new URL(url, options._baseURL);
      } else if (typeof url === "string" && !isAbsoluteURL(url) && getBundleURL().match(/^file:\/\//i)) {
        url = new URL(url, getBundleURL().replace(/\/[^\/]+$/, "/"));

        if ((_a = options === null || options === void 0 ? void 0 : options.CORSWorkaround) !== null && _a !== void 0 ? _a : true) {
          url = createSourceBlobURL("importScripts(".concat(JSON.stringify(url), ");"));
        }
      }

      if (typeof url === "string" && isAbsoluteURL(url)) {
        // Create source code blob loading JS file via `importScripts()`
        // to circumvent worker CORS restrictions
        if ((_b = options === null || options === void 0 ? void 0 : options.CORSWorkaround) !== null && _b !== void 0 ? _b : true) {
          url = createSourceBlobURL("importScripts(".concat(JSON.stringify(url), ");"));
        }
      }

      return _super.call(this, url, options);
    }

    return WebWorker;
  }( /*#__PURE__*/_wrapNativeSuper(Worker));

  var BlobWorker = /*#__PURE__*/function (_WebWorker) {
    _inherits(BlobWorker, _WebWorker);

    var _super2 = _createSuper(BlobWorker);

    function BlobWorker(blob, options) {
      _classCallCheck(this, BlobWorker);

      var url = window.URL.createObjectURL(blob);
      return _super2.call(this, url, options);
    }

    _createClass(BlobWorker, null, [{
      key: "fromText",
      value: function fromText(source, options) {
        var blob = new window.Blob([source], {
          type: "text/javascript"
        });
        return new BlobWorker(blob, options);
      }
    }]);

    return BlobWorker;
  }(WebWorker);

  return {
    blob: BlobWorker,
    default: WebWorker
  };
}

var implementation;
export function getWorkerImplementation() {
  if (!implementation) {
    implementation = selectWorkerImplementation();
  }

  return implementation;
}
export function isWorkerRuntime() {
  var isWindowContext = typeof self !== "undefined" && typeof Window !== "undefined" && self instanceof Window;
  return typeof self !== "undefined" && self.postMessage && !isWindowContext ? true : false;
}